var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48576",
    "data-name": "Group 48576",
    transform: "translate(-916 -695)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138030",
    "data-name": "Rectangle 138030",
    width: 24,
    height: 24,
    transform: "translate(916 695)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49791",
    "data-name": "Group 49791",
    transform: "translate(-444.227 612.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93675",
    "data-name": "Path 93675",
    d: "M3.607,7.417h0A2.857,2.857,0,0,0,.75,10.274v3.81a3.809,3.809,0,0,0,3.809,3.809H8.465a6.669,6.669,0,0,1,4.714,1.953l.9.9V15.036",
    transform: "translate(1361 83.5)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93676",
    "data-name": "Path 93676",
    d: "M17.893,11.226H11.457a2.857,2.857,0,0,0-2.02.837l-2.02,2.02V4.559A3.809,3.809,0,0,1,11.226.75h6.667A3.809,3.809,0,0,1,21.7,4.559V7.416A3.81,3.81,0,0,1,17.893,11.226Z",
    transform: "translate(1361 83.5)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMode);
export default __webpack_public_path__ + "static/media/Mode.2e31b737f680d01bc19be47ff523db6d.svg";
export { ForwardRef as ReactComponent };